import React from 'react';
import PropTypes from 'prop-types';
import { Link, LinkProps } from 'react-router-dom';

interface Props extends LinkProps {
    label: string;
    icon?: string;
}

const NavItem = ({ to, label, icon, ...props }: Props) => {
    return (
        <Link style={{ textDecoration: 'none' }} to={to} {...props}>
            {label}
        </Link>
    );
};

NavItem.propTypes = {
    to: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
};

export default NavItem;
